import { useEffect, useState } from 'react';
import { useAppSelector } from 'src/store';
import { usePagedConfigurationSettings } from 'src/pages/ConfigurationPage/hooks/usePagedConfigurationSettings';
import type { ConfigurationSettings } from 'src/services/configurationService';

// Loads all of a project's configuration settings versions and picks the one the
// creation flow built with the prompt builder. `settings` stays null until the first page loads.
export const useCreationFlowSettings = (
  id: string,
  queryOptions: { skip: boolean; refetchOnMountOrArgChange?: boolean },
) => {
  const creationFlowState = useAppSelector((s) => s.creationFlowSlices);
  const [activeSettings, setActiveSettings] = useState<ConfigurationSettings | null>(null);

  const { settings, isLoadingAllConfigurationSettings } = usePagedConfigurationSettings(
    id,
    queryOptions,
    null,
  );

  useEffect(() => {
    if (settings) {
      const config = creationFlowState[id];
      const settingsId = config.promptBuilderSettingsId;

      if (settingsId && settings.length) {
        const setting = settings.find((setting) => `${setting.id}` === `${settingsId}`);

        setting && setActiveSettings(setting);
      }
    }
  }, [settings, creationFlowState]);

  return { settings, activeSettings, isLoadingAllConfigurationSettings };
};
